export default {
  dataIterator: {
    rowsPerPageText: 'Items por pág:',
    rowsPerPageAll: 'Todo',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'No se encontraron registros',
    nextPage: 'Próx pag',
    prevPage: 'Pag ant'
  },
  dataTable: {
    rowsPerPageText: 'Filas por pag:'
  },
  noDataText: 'No hay datos'
}



// WEBPACK FOOTER //
// ./resources/assets/js/lang/es.js